// START:STYLES
import './styles/index.scss';
// END:STYLES

import Vue from 'vue';

// START:CONIFG
import router from './config/router';
import { state } from './config/store';
import i18n from './config/i18n';
import './config/meta';
import './config/moment';
import './config/analytics';
import './config/firebase';
import './config/portal';
import './config/payment';
import './config/globalComponents';
// END:CONFIG

// START:LOAD_COMPONENTS
import App from './App.vue';
// END:LOAD_COMPONENTS


Vue.config.productionTip = false;
Vue.config.errorHandler = (err, vm) => {
  vm.$trackError(err);
};

new Vue({
  data: { shared: state },
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
